<template>
	<div class="rebag">
		<TwoHeader></TwoHeader>
		<div class="bgcontent">
			<div class="box-card">
				<LeftNav></LeftNav>
				<div class="baoright" v-show="Show">
					<h2 class="yutitle">
						<span></span>{{ userexaminfo.examinationName }}费用支付
					</h2>
					<table class="toptable">
						<tr>
							<td class="yusteon">考生请注意：</td>
							<td valign="center" rowspan="1" colspan="11" class="yutext">
								<span style="color: red; font-weight: bold">在线支付成功后，报名方为有效，且所有信息均不允许修改</span>
							</td>
						</tr>
						<tr>
							<td class="yusteon">考生号</td>
							<td class="yutext">
								{{ userexaminfo.signUpNo
                }}<span style="color: red; font-weight: bold; margin-left: 20px">【请牢记报名序号】</span>
							</td>
							<td class="yutext"></td>
						</tr>
						<tr>
							<td class="yusteon">姓名</td>
							<td valign="center" rowspan="1" colspan="11" class="yutext">
								{{ userexaminfo.registrationName }}
							</td>
						</tr>
						<tr>
							<td class="yusteon">证件号码</td>
							<td valign="center" rowspan="1" colspan="11" class="yutext">
								{{ userexaminfo.idcard }}
							</td>
						</tr>
						<tr>
							<td class="yusteon">支付名称</td>
							<td valign="center" rowspan="1" colspan="11" class="yutext">
								{{ userexaminfo.examinationName }}
							</td>
						</tr>
						<tr>
							<td class="yusteon">支付金额</td>
							<td valign="center" rowspan="1" colspan="11" class="yutext">
								￥ {{ examDetail.payment }}元
							</td>
						</tr>
						<tr v-if="payed == 1">
							<td class="yusteon">缴费状态</td>
							<td valign="center" rowspan="1" colspan="11" class="yutext" style="color: #5daf34">
								缴费已完成
							</td>
						</tr>
						<tr>
							<td class="yusteon">支付说明</td>
							<td valign="center" class="yutext">
								<p style="text-align: left; font-size: 14px">
									1.在现支付首先进入支付系统页面；
								</p>
								<p style="text-align: left; font-size: 14px">
									2.然后选择平台相应的支付方式进行支付；
								</p>
								<P style="text-align: left; font-size: 14px; font-size: 14px">3.请考生按照流程一步一步操作，请勿提前关闭浏览器；
								</P>
								<P style="text-align: left; font-size: 14px">4.待显示支付完成再进行下步操作。</P>
							</td>
							<td valign="center" rowspan="1" colspan="2" class="yutext">
								<span style="color: red; font-weight: bold">认真阅读支付说明</span>
							</td>
						</tr>
					</table>
					<div class="divbut" v-if="payed != 1">
						<!--					<div class="divbut" >-->
						<button>上一步</button>
						<button @click="pay" style="width: 160px">同意并支付</button>
					</div>
					<!--          <div class="divbut" v-if="$store.state.userexaminfo.payed==1">-->
					<!--            <span style="color: #fff;border: #bbb 1px solid;background-color:#5daf34;width: 200px;height: 60px !important;line-height: 60px !important;">已完成缴费</span>-->
					<!--          </div>-->
				</div>
				<div class="baoright wx" v-show="!Show">
					<div style="width: 50%">
						<div class="wx1">￥{{ examDetail.payment }}</div>
						<div class="qrcode" ref="qrCodeUrl"></div>
						<div class="wx2">温馨提示：付款后即可完成报名</div>
					</div>
					<div style="width: 50%">
						<img src="../assets/wx.png" alt="" />
					</div>
				</div>
			</div>
		</div>
		<FooTer></FooTer>
		<!--		<footer>-->
		<!--			<Span>版权所有：中智云达 2020-2025 All Rights Reserved.</Span>-->
		<!--			<span class="kfoter">地址：条山街区委家属院</span>-->
		<!--			<span>ICP证:晋ICP备12002626号 </span>-->
		<!--		</footer>-->
		<!--    <div class="confirmpay" v-if="paying">-->
		<!--      <div>-->
		<!--        <img src="../assets/paying.jpg" alt="">-->
		<!--      </div>-->
		<!--      <div class="btngroup">-->
		<!--        <button @click="completepay">取消支付</button>-->
		<!--        <button @click="completepay">支付完成</button>-->
		<!--      </div>-->

		<!--    </div>-->
		<!--    <div class="mask" v-if="paying">-->

		<!--    </div>-->
	</div>
</template>

<script>
	import QRCode from "qrcodejs2";
	import TwoHeader from "../components/common/twoheader.vue";
	import LeftNav from "../components/common/leftnav.vue";
	import {
		examineeInfo,
		examDetail,
		unifiedOrder,
		orderquery
	} from "@/api/api";
	import FooTer from "../components/common/footer.vue";
	import {
		mapState
	} from "vuex";
	import $ from "jquery";
	export default {
		name: "pay",
		components: {
			TwoHeader,
			LeftNav,
			FooTer,
		},
		data() {
			return {
				paying: false,
				examDetail: {},
				Show: true,
				wxurl: "",
				orderNo: "",
				payed: 0,
			};
		},
		created() {
			examDetail({
				id: this.$store.state.examid
			}).then((res) => {
				this.examDetail = res.data.data;
			});
			var orderNo = ''
			unifiedOrder({
					type: "PC",
					examineeInfoId: this.userexaminfo.id
				},
				this.token
			).then((res) => {
				console.log(res);
				if (res.data.code == 301) {
					this.Show = true;
					this.payed = 1;
					return false
				}
				orderNo = res.data.data.orderNo;
				orderquery({
					orderNo: orderNo
				}, this.token).then((res) => {
					console.log(res.data.code);
					// if (res.data.code == 0) {
					// 	this.Show = true;
					// 	this.payed = 1;
					// }
				});
			});

		},
		computed: {
			...mapState({
				token: "token",
				userexaminfo: "userexaminfo",
				examid: "examid",
			}),
		},
		mounted() {
			// this.creatQrCode();
		},
		methods: {
			creatQrCode() {
				let that = this;

				new QRCode(this.$refs.qrCodeUrl, {
					text: that.wxurl, // 需要转换为二维码的内容
					width: 200,
					height: 200,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H,
				});
			},
			pay() {
				var that = this;
				var servetime = new Date(
					$.ajax({
						type: "HEAD",
						async: false,
						cache: false
					}).getResponseHeader(
						"Date"
					)
				);

				if (
					Date.parse(servetime) >=
					Date.parse(this.examDetail.payEndTime.replace(/-/g, "/"))
				) {
					this.$confirm("本次考试已经停止缴费！", "温馨提示", {
						showCancelButton: false,
						confirmButtonText: "我知道了",
						type: "warning",
					}).then(() => {
						return false;
					});
					return false;
				}
				unifiedOrder({
						type: "PC",
						examineeInfoId: this.userexaminfo.id
					},
					this.token
				).then((res) => {
					console.log(res.data.data);
					this.wxurl = res.data.data.codeUrl;
					this.orderNo = res.data.data.orderNo;
					this.Show = false;
					this.creatQrCode();

					let wxsetInterval = setInterval(function() {
						orderquery({
							orderNo: that.orderNo
						}, that.token).then((res) => {
							console.log(res.data.code);
							if (res.data.code == 0) {
								that.Show = true;
								that.payed = 1;
								clearInterval(wxsetInterval);
							}
						});
					}, 3000);
				});
				// submitpay({ examineeInfoId: this.userexaminfo.id }, this.token).then(
				//   (res) => {
				//     if (res.data.code == 0) {
				//       // this.$message({
				//       //   showClose: true,
				//       //   message: '缴费成功！',
				//       //   type: 'success'
				//       // });
				//       // window.open(res.data.msg,"_blank");
				//       // window.open(res.data.msg,"_self");
				//       this.Show = false;
				//       this.paying = true;

				//       // examineeInfo({'examinationId':this.examid},this.token).then(res1=>{
				//       //   this.$store.commit('updateUserexaminfo',res1.data.data[0]);
				//       // })
				//     } else {
				//       this.$confirm(res.data.msg, "温馨提示", {
				//         // cancelButtonText: '取消',
				//         confirmButtonText: "确定",
				//         type: "warning",
				//       });
				//     }
				//   }
				// );
			},
			cacalpay() {
				this.paying = false;
			},
			completepay() {
				this.paying = false;
				examineeInfo({
					examinationId: this.examid
				}, this.token).then((res1) => {
					if (res1.data.data[0].payed == 1) {
						this.$message({
							showClose: true,
							message: "支付成功！",
							type: "success",
						});
						this.$store.commit("updateUserexaminfo", res1.data.data[0]);
					} else {
						this.$message({
							showClose: true,
							message: "支付失败！",
							type: "error",
						});
					}
				});
			},
		},
	};
</script>

<style scoped="">
	.wx {
		padding-top: 150px !important;
		display: flex;
		justify-content: space-between;
	}

	.wx1 {
		font-size: 50px;
		margin-left: 100px;
	}

	.wx2 {
		font-size: 20px;
		margin-left: 100px;
		padding-top: 20px;
		color: red;
	}

	.qrcode {
		margin-left: 200px;
	}

	.rebag {
		background: url("../assets/denglu.png");
		background-size: cover;
	}

	.bright {
		float: right;
	}

	.brightp {
		line-height: 130px;
		color: #ffffff !important;
		font-size: 16px;
		margin-left: 20px;
		list-style: none;
	}

	.brightp i {
		font-size: 20px;
	}

	.bgcontent {
		margin-top: 40px;
		min-height: 790px;
	}

	.el-card {
		border: none;
	}

	.box-card {
		margin: 0 auto;
		width: 1200px;
		margin: 0 auto;
		height: auto;
		overflow: hidden;
		margin-bottom: 50px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
		background-color: #ecf4ff;
	}

	.baoimeg {
		width: 180px;
		background: linear-gradient(to left, #54abff 0%, #0048d0 100%);
		display: block;
		height: 64px;
		line-height: 64px;
		color: #ffffff;
	}

	.baoright {
		float: left;
		width: 979px;
		background-color: #ffffff;
		padding: 20px;
		padding-bottom: 80px;
		min-height: 540px;
	}

	table {
		width: 950px;
		text-align: center;
		/* 表边框合并  两个单元格之间的边框进行合并 */
		border-collapse: collapse;
		margin: 0 auto;
		margin-top: 2px;
	}

	table td {
		border-width: 1px;
		border-style: solid;
		background-color: white;
		height: 40px;
		width: 100px;
		border: 1px #e0e0e0 solid;
	}

	table th {
		background-color: white;
		height: 40px;
		width: 100px;
	}

	.yusteon {
		font-weight: bold;
		width: 160px;
		font-size: 14px;
	}

	.yutext {
		text-align: left;
		padding-left: 20px;
		font-size: 14px;
	}

	.toptable {
		margin-top: 20px;
	}

	.divbut {
		margin-top: 50px;
	}

	.divbut button {
		width: 100px;
		height: 32px;
		margin-right: 20px;
		cursor: pointer;
	}

	footer {
		background-color: #b8d7ff;
		width: 100%;
		line-height: 60px;
		font-size: 14px;
		position: fixed;
		bottom: 0;
	}

	.kfoter {
		margin: 0px 20px;
	}

	.mask {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background-color: rgba(100, 100, 100, 0.5);
		z-index: 1000;
	}

	.confirmpay {
		width: 30%;
		height: 300px;
		margin: 0 auto;
		background-color: #fff;
		position: fixed;
		top: 30%;
		left: 35%;
		z-index: 1001;
		display: flex;
		flex-direction: column;
		/*justify-content: space-around;*/
		align-items: center;
	}

	.btngroup {
		width: 300px;
		display: flex;
		justify-content: space-around;
	}

	.btngroup button {
		width: 100px;
		height: 32px;
		margin-right: 20px;
		cursor: pointer;
	}
</style>
